import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';

export const StyledQuickFiltersContainer = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    margin-top: 10px;
    ${media.mobileDevice`
        margin-bottom: 20px; 
    `};
`;

export const StyledQuickFilterGrid = styled.ul`
    margin: 0;
    padding: 0;
    width: 100%;
    display: grid;
    grid-auto-rows: 3.25rem;
    grid-template-columns: repeat(9, 1fr);
    gap: 5px;
    box-sizing: border-box;

    @media only screen and (min-device-width: 834px) and (max-device-width: 1112px) and (orientation : landscape){
        grid-template-columns: repeat(7, 1fr);
    }

    @media screen and (orientation: landscape) and (max-width: 1366px) {
        grid-template-columns: repeat(7, 1fr);
    }

    ${media.mediumDevice`
        grid-template-columns: repeat(5,1fr);
    `};
    ${media.smalDevice`
        grid-template-columns: repeat(5,1fr);
    `};
    ${media.mobileDevice`
        grid-auto-rows:3.75rem;
        gap: 0px;
        grid-template-columns: repeat(5,1fr);
        max-width: 100%;
        min-width: 95%;
        
    `};
    ${media.exSmallDevice`
        max-width: 95%;
        min-width: 90%;
    `};
`;

export const StyledQuickFilter = styled.li`
    display: flex;
    width: 100%;

    box-sizing: border-box;
    background-color: ${({ isSelected }) =>
        isSelected ? '#FFFFFF' : '#EBEDED'};
    border: ${({ isSelected }) =>
        isSelected ? 'none' : '0.5px solid #D7DBDB'};
    opacity: 1;
    height: 100%;
    box-shadow: 0px 0px 6px #00000014;
    align-items: center;
    flex-direction: column;
    position: relative;
    cursor: ${(props) => (props.cursor ? props.cursor : 'none')};
    ${media.mobileDevice`
        width: 100%;
        box-shadow: none;
        &:nth-child(n+6){
            display: none;
            display: ${({ showFullFilter }) =>
                showFullFilter ? 'flex' : 'none'};
        }
    `}
`;

export const StyledFilterContent = styled.div`
    display: flex;
    height: 95%;
    width: 100%;
    align-items: center;

    ${({ isBatch }) =>
        isBatch &&
        css`
            &:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                width: 0;
                height: 0;
                border-top: ${({ isPending }) =>
                    isPending ? '10px solid  #E89000' : '10px solid #ED002A'};
                border-left: 10px solid transparent;
            }
        `}

    ${media.mobileDevice`
            max-width: 100%;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
        `}
`;

export const StyledQuickFilterIcon = styled(StyledQuickFilter)`
    display: none;
    width: 100%;
    background-color: #ebeded;
    align-items: center;
    justify-content: center;
    ${media.mobileDevice`
        display: ${({ isShowIcon }) => (isShowIcon ? 'flex' : 'none')}; 
        grid-row-start: 1;
        grid-row-end: 1;
        grid-column-start: 5;
        grid-column-end: 5;
    `}
`;

export const StyledFilterIcon = styled.div`
    width: 20%;
    height: 20%;
    background-image: url(${({ imgUrl }) => imgUrl && imgUrl});
    background-repeat: no-repeat;
    background-size: contain;
    background-color: '#EBEDED';
`;

export const StyledQuickFilterBorder = styled.div`
    border-bottom: ${({ isSelected }) =>
        isSelected ? '3px solid #1010EB' : '3px solid transparent'};
    width: 100%;
    height: 5%;
`;

export const StyledQuickFont = styled.p`
    font-family: ${({ isFiltername, isFilterCount }) =>
        isFiltername
            ? 'AvenirNextWorld Demi'
            : isFilterCount && 'AvenirNextWorld Bold'};
    margin: 0;
    flex-grow: ${({ isFiltername }) => (isFiltername ? '2' : '1')};
    color: ${({ isSelected, isColor }) =>
        isSelected ? '#1010EB' : isColor ? isColor : '#4F4F4F'};
    opacity: 1;
    text-align: ${({ isFiltername, isFilterCount }) =>
        isFiltername ? 'left' : isFilterCount && 'left'};
    font-size: ${({ isFiltername, isFilterCount }) =>
        isFiltername ? '14px' : isFilterCount && '18px'};
    padding: ${({ isFiltername, isFilterCount }) =>
        isFiltername ? '0 0 0 0.3rem' : isFilterCount && '0 0.1rem 0 0.2rem'};
    max-width: ${({ isFiltername }) => isFiltername && '70%'};
    line-height: ${({ isFiltername, isFilterCount }) =>
        isFiltername ? '16px' : isFilterCount && '10px'};

    ${media.mobileDevice`
        font-size: ${({ isFiltername, isFilterCount }) =>
            isFiltername ? '10px' : isFilterCount && '16px'};
        max-width: 75%;
        flex-grow: 1;
        line-height: ${({ isFiltername, isFilterCount }) =>
            isFiltername ? '12px' : isFilterCount && '17px'};
        padding: ${({ isFiltername }) =>
            isFiltername ? '0.3rem 0 0 0.3rem' : '0 0 0 0.3rem'};
        height: ${({ isFiltername, isFilterCount }) =>
            isFiltername ? '70%' : isFilterCount && '30%'};
        text-align: ${({ isFilterCount }) => isFilterCount && 'left'};
    `}
    ${media.exSmallDevice`
        padding: 0.1rem;
        max-width: 90%;
        line-height: 15px;
        text-align: left;
    `}
`;
